<template>
    <div id="estados-component" class="rel">
        <main id="mainContent" class="padFixBoth">
            <form id="formCrud" class="animated fadeInUp">
                <div class="row scr-gap-15-0">
                    <div class="col-12 col-xl-8">
                        <input placeholder="Nombre del Documento" type="text" class="al-inputs required scr-input" name="name_file" id="name_file" v-model="kindFile.name_file"/>
                        <label for="name_file" class="scr-supertext scr-extra">Nombre del Documento</label>
                    </div>

                    <div class="col-12 col-xl-3 offset-xl-1">
                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar()">{{ tituloBtn }}</button>
                    </div>
                </div>
            </form>
            <main id="mainContent" class="padFixBoth">
                <div class="container-fluid">
                    <div class="row">
                        <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy" :items="files" show-empty :filter="filter">
                            <template #empty="scope">
                                <h4 class="emptyRow">
                                    No hay datos para mostrar.
                                </h4>
                            </template>
                            <template #cell(documento)="{item}">
                                <span>{{ item.name_file }}</span>
                            </template>
                            <template #cell(acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)" v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)" v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Cargando...</strong>
                                </div>
                            </template>

                        </b-table>
                    </div>
                </div>
            </main>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {kindfilestationeryService} from "../../Services/KindFileStationery.service";

export default {
    name: "estado",
    mixins: [myMixins],
    data() {
        return {
            filter: null,
            isBusy: false,
            kindFile: {
                id: '',
                name_file: '',
            },
            fields: [
                {key: "documento"},
                {key: "acciones"}
            ],
            modificar: false,
            modal: 0,
            tituloModal: '',
            files: [],
            loading: true,
            myTableFlag: false,
            tituloBtn: 'Agregar',
        }
    },
    methods: {
        updateReg(data = {}) {
            this.modal = 1
            if (this.modificar) {
                this.tituloBtn = 'Actualizar'
                this.kindFile = data;
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        async onClickDelete(id) {
            let resp = '';
            resp = await kindfilestationeryService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async index() {
            this.files = await kindfilestationeryService.getMany();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3();
            if (respVal) {
                this.disableSubmitBtn(true);
                if (this.modificar) {
                    resp = await kindfilestationeryService.updateOne(this.kindFile.id, this.kindFile);
                    this.modificar = false;
                } else {
                    resp = await kindfilestationeryService.saveOne(this.kindFile);
                }
                this.disableSubmitBtn(false);
            }
            this.setEmpty();
            this.getAlert(resp.process);
            await this.index();
            this.modificar = false;

        },
        setEmpty() {
            this.kindFile = {
                id: '',
                name_file: '',
            };
        }
    },
    created() {
        this.index();
    }
}
</script>

